/**
 * Email domain validation utility for restricting registration to authorized domains
 */

export const ALLOWED_DOMAIN = '@dfx5.com';
export const DOMAIN_ERROR_MESSAGE = 'Registration is restricted to @dfx5.com email addresses only';

/**
 * Validates that an email address belongs to the allowed domain
 * @param email - The email address to validate
 * @returns true if the email ends with the allowed domain (case-insensitive), false otherwise
 */
export function validateEmailDomain(email: string): boolean {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const normalizedEmail = email.toLowerCase().trim();
  const normalizedDomain = ALLOWED_DOMAIN.toLowerCase();

  return normalizedEmail.endsWith(normalizedDomain);
}

/**
 * Gets the allowed domain for display purposes
 * @returns The allowed domain string
 */
export function getAllowedDomain(): string {
  return ALLOWED_DOMAIN;
}

/**
 * Gets the validation error message
 * @returns The error message to display when domain validation fails
 */
export function getValidationError(): string {
  return DOMAIN_ERROR_MESSAGE;
}
